"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceDoorTilesWithDoorObjects = exports.addTestItems = exports.addInitialPotions = exports.addInitialWeapons = exports.addSpiderStuff = exports.addBarrels = exports.addTreasure = exports.addObject = exports.addLamps = void 0;
var diveObjectsData_sidecar_1 = require("@dive/entities/diveObjectsData-sidecar");
var diveTileData_1 = require("../../tilemap/diveTileData");
var diveTileData_sidecar_1 = require("../../tilemap/diveTileData-sidecar");
var diveTilemapPart_sidecar_1 = require("../../tilemap/diveTilemapPart-sidecar");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveObjectsData_1 = require("@dive/entities/diveObjectsData");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var genUtils_1 = require("../common/genUtils");
function addLamps(info, min, max) {
    var rnd, numObjects;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rnd = info.rnd;
                min = Math.round(min);
                max = Math.round(max);
                numObjects = rnd.i(min, max);
                return [5 /*yield**/, __values(addObject(info, numObjects, diveObjectsData_1.EDiveObjectType.Firepit))
                    // // Add 5-10 lamps
                    // let numLamps = rnd.i(min, max)
                    // for (let iLamp = 0; iLamp < numLamps; iLamp++) {
                    //   for (let iAttempt = 0; iAttempt < 10; iAttempt++) {
                    //     if (openFloors.length === 0) {
                    //       break
                    //     }
                    //     let spot = rnd.sampleAndRemove(openFloors)
                    //     if (isClear8(spot.i, spot.j)) {
                    //       let lamp = diveTileData.get(EDiveTile.Lamp)
                    //       diveTilemapPart.setTile(spot, lamp)
                    //       break
                    //     }
                    //     // Try again
                    //   }
                    // }
                ];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.addLamps = addLamps;
function addObject(info, numObjects, type) {
    var rnd, openFloors, iObject, iAttempt, spot, objectData, obj;
    return __generator(this, function (_a) {
        rnd = info.rnd, openFloors = info.openFloors;
        for (iObject = 0; iObject < numObjects; iObject++) {
            for (iAttempt = 0; iAttempt < 10; iAttempt++) {
                if (openFloors.length === 0) {
                    break;
                }
                spot = rnd.sampleAndRemove(openFloors);
                if (genUtils_1.isClear8(spot.i, spot.j)) {
                    objectData = diveObjectsData_sidecar_1.diveObjectsData.find(type);
                    assert_sidecar_1.assert.notNil(objectData);
                    obj = diveObjects_sidecar_1.diveObjects.create(0, objectData);
                    diveObjects_sidecar_1.diveObjects.moveToIJ(obj, spot.i, spot.j);
                    break;
                }
                // Try again
            }
        }
        return [2 /*return*/];
    });
}
exports.addObject = addObject;
function addTreasure(info, min, max) {
    var rnd, numObjects;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rnd = info.rnd;
                min = Math.round(min);
                max = Math.round(max);
                numObjects = rnd.i(min, max);
                return [5 /*yield**/, __values(addObject(info, numObjects, diveObjectsData_1.EDiveObjectType.TreasureChest))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.addTreasure = addTreasure;
function addBarrels(info, min, max) {
    var rnd, datas, i, type, numObjects;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rnd = info.rnd;
                min = Math.round(min);
                max = Math.round(max);
                datas = [diveObjectsData_1.EDiveObjectType.Barrel, diveObjectsData_1.EDiveObjectType.Crate];
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < datas.length)) return [3 /*break*/, 4];
                type = datas[i];
                numObjects = Math.round(rnd.i(min, max) / 2);
                return [5 /*yield**/, __values(addObject(info, numObjects, type))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
exports.addBarrels = addBarrels;
function addSpiderStuff(info, min, max) {
    var rnd, datas, i, type, numObjects;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rnd = info.rnd;
                min = Math.round(min);
                max = Math.round(max);
                datas = [diveObjectsData_1.EDiveObjectType.SpiderEgg, diveObjectsData_1.EDiveObjectType.SpiderWeb];
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < datas.length)) return [3 /*break*/, 4];
                type = datas[i];
                numObjects = Math.round(rnd.i(min, max) / 2);
                return [5 /*yield**/, __values(addObject(info, numObjects, type))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
exports.addSpiderStuff = addSpiderStuff;
function addInitialWeapons(info) {
    var datas, i, type;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                datas = [
                    diveObjectsData_1.EDiveObjectType.Weapon_Sword,
                    diveObjectsData_1.EDiveObjectType.Weapon_Spellbook,
                    diveObjectsData_1.EDiveObjectType.Weapon_Bow,
                ];
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < datas.length)) return [3 /*break*/, 4];
                type = datas[i];
                return [5 /*yield**/, __values(addObject(info, 1, type))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
exports.addInitialWeapons = addInitialWeapons;
function addInitialPotions(info) {
    var datas, i, type;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                datas = [
                    diveObjectsData_1.EDiveObjectType.Potion1,
                    diveObjectsData_1.EDiveObjectType.Potion1,
                    diveObjectsData_1.EDiveObjectType.Potion2,
                    diveObjectsData_1.EDiveObjectType.Potion2,
                ];
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < datas.length)) return [3 /*break*/, 4];
                type = datas[i];
                return [5 /*yield**/, __values(addObject(info, 1, type))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
exports.addInitialPotions = addInitialPotions;
function addTestItems(info) {
    var rnd, datas, i, type, numObjects;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rnd = info.rnd;
                datas = [
                    diveObjectsData_1.EDiveObjectType.GoldPile,
                    diveObjectsData_1.EDiveObjectType.Key1,
                    diveObjectsData_1.EDiveObjectType.Key2,
                    diveObjectsData_1.EDiveObjectType.Potion1,
                    diveObjectsData_1.EDiveObjectType.Potion2,
                    diveObjectsData_1.EDiveObjectType.Weapon_Sword,
                    diveObjectsData_1.EDiveObjectType.Weapon_Spellbook,
                    diveObjectsData_1.EDiveObjectType.Weapon_Bow,
                    diveObjectsData_1.EDiveObjectType.Scroll,
                ];
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < datas.length)) return [3 /*break*/, 4];
                type = datas[i];
                numObjects = rnd.i(4, 8);
                return [5 /*yield**/, __values(addObject(info, numObjects, type))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
exports.addTestItems = addTestItems;
function replaceDoorTilesWithDoorObjects(info) {
    var rnd, dDoor, dFloor, _a, w, h, j, i, gs, obj;
    return __generator(this, function (_b) {
        rnd = info.rnd;
        dDoor = diveObjectsData_sidecar_1.diveObjectsData.find(diveObjectsData_1.EDiveObjectType.Door);
        assert_sidecar_1.assert.notNil(dDoor);
        dFloor = diveTileData_sidecar_1.diveTileData.get(diveTileData_1.EDiveTile.Floor);
        _a = __read(diveTilemap_sidecar_1.diveTilemap.getSize(), 2), w = _a[0], h = _a[1];
        for (j = 0; j < h; j++) {
            for (i = 0; i < w; i++) {
                gs = diveTilemap_sidecar_1.diveTilemap.getUnsafe(i, j);
                if (gs.tile1.type === diveTileData_1.EDiveTile.DoorClosed) {
                    diveTilemapPart_sidecar_1.diveTilemapPart.setTile(gs, dFloor);
                    obj = diveObjects_sidecar_1.diveObjects.create(0, dDoor);
                    diveObjects_sidecar_1.diveObjects.moveToIJ(obj, i, j);
                    if (rnd.chance(0.25)) {
                        obj.isOpen = true;
                    }
                }
            }
        }
        return [2 /*return*/];
    });
}
exports.replaceDoorTilesWithDoorObjects = replaceDoorTilesWithDoorObjects;
